import { render } from "./AboutMeSection.vue?vue&type=template&id=17807bc4&scoped=true"
import script from "./AboutMeSection.vue?vue&type=script&lang=js"
export * from "./AboutMeSection.vue?vue&type=script&lang=js"

import "./AboutMeSection.vue?vue&type=style&index=0&id=17807bc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Desktop\\PROJECTS\\portfolio\\v1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17807bc4"]])

export default __exports__